<template>
  <!-- 顶部导航 -->
  <div class="header">
    <div class="nav-topbar">
      <div class="container">
        <div class="left">
          <div>选择城市：</div>
          <el-select v-model="defCityName"
                     filterable
                     size="small"
                     placeholder="请选择"
                     value-key="id"
                     @change="changeCity($event)">
            <el-option v-for="item in cityList"
                       :key="item.id"
                       :label="item.name"
                       :value="item">
            </el-option>
          </el-select>
          <!-- <iframe id="geoPage"
                  width=0
                  height=0
                  frameborder=0
                  style=""
                  scrolling="no"
                  src="https://apis.map.qq.com/tools/geolocation?key=J4OBZ-EONKG-CMOQB-I5KJR-ET2MS-T7F5W&referer=myapp">

          </iframe> -->
        </div>
        <div class="right"
             v-if="tokenShow">
          <div class="dropdown">
            <el-dropdown trigger="click"
                         @command="handleCommand">
              <span class="el-dropdown-link">
                Hi,{{ !userInfo.nickName?'暂无昵称':userInfo.nickName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">个人信息</el-dropdown-item>
                <el-dropdown-item command="2">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="line"></div>
          <div class="name"
               @click="jumpMovieOrder">电影订单</div>
          <div class="line"></div>
          <div class="name"
               @click="jumpOrder">我的订单</div>
          <div class="line"></div>
          <div class="name"
               @click="toPersonalCenter">个人中心</div>
        </div>
        <div class="right"
             v-else>
          <div class="login-box"
               @click="goLogin">
            <span>请先<span class="login">登录</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-headers"
         :style="'background-color:'+navBack">
      <div class="
         box1">
        <a href="/#/index">
          <div class="left">
            <img class="logo"
                 src="/images/logo1.png"
                 alt />
            <div class="line"></div>
            <div class="name"
                 :style="'color:'+fontsColor">汇采实业直营商城</div>
          </div>
        </a>

        <div class="inp_box"
             @click="jumpList('','')">
          <img src="/images/search_gray.png"
               alt="">
          <div class="word">请输入关键词</div>
          <!-- <input type="text"
                 v-model="keyword"
                 placeholder="请输入关键词"
                 disabled> -->
          <div class="btn"
               :style="'background-color:'+themeColor">搜索</div>
        </div>
        <div class="car_box"
             @click="jumpCar">
          <i class="el-icon-shopping-cart-2"></i>
          <span class="word">购物车</span>
          <span class="num">{{ cartNum }}</span>
        </div>
      </div>
      <div class="box2">
        <div class="fenlei">
          <div class="name-box"
               :style="'background-color:'+themeColor">
            <i class="el-icon-s-operation"></i>
            <span class="word">特惠专区</span>
          </div>
          <div class="category">
            <div class="childrenOne">
              <div class="item"
                   v-for="(first,index1) in firstList"
                   :key="index1"
                   @click.stop="jumpList(first,1)"
                   @mouseenter.stop="hoverFirst(first,index1)"
                   v-show="first.count > 0">
                <div class="word">{{ first.name }}</div>
              </div>
            </div>
            <div class="childrenTwo"
                 v-if="show">
              <div class="two"
                   v-for="(second,index2) in secondList"
                   :key="index2"
                   @click.stop="jumpList(second,2)">
                <div class="second">{{ second.name }}</div>
                <div class="third_box">
                  <div class="third"
                       v-for="(third,index3) in second.subcategorization"
                       :key="index3"
                       @click.stop="jumpList(third,3)">
                    <div class="third_item">
                      <div class="third_name">{{ third.name }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="empty"
                   v-if="secondList.length == 0">
                <div class="line"></div>
                <span>暂无数据</span>
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="tabs"
             :style="'color:'+fontsColor">
          <div class="word"
               @click="jumpModule(1)">京东专区</div>
          <div class="word"
               @click="jumpModule(2)">蛋糕专区</div>
          <div class="word"
               @click="jumpModule(3)">电影专区</div>
          <div class="word"
               @click="jumpModule(4)">虚拟卡券</div>
          <!-- <div class="word"
               @click="jumpIntegral">积分商城</div> -->
          <div v-if="this.columnList.length == 0"></div>
          <div class="word"
               v-else
               v-for="(item,index) in columnList"
               @click="jumpColumn(item)"
               :key="index">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { loadBMap } from '@/utils/loadResources';
export default {
  name: 'nav-header',
  data () {
    return {
      keyword: '',
      firstList: [],
      secondList: [],
      hoverIndex: null,
      tokenShow: false,
      userInfo: {},
      columnList: [],
      cartNum: 0,
      companyActivity: '',
      show: false,
      defCityName: '',
      cityId: '',
      cityList: [],
      isLocation: false
    };
  },
  created () {
    // this.$store.dispatch('saveCakeCityId', '')
    // this.$store.dispatch('saveCakeCityName', '')
    // this.$store.dispatch('saveCakeCityLocation', {})
    window.initBaiduMapScript = () => {
      console.log(BMap);
      this.getlocation();
    }
    loadBMap('initBaiduMapScript');
    this.cityId = this.cakeCityId

    // 主题色
    this.$store.dispatch('saveThemeColor', '#ff0000')
  },
  mounted () {

    if (!localStorage.getItem('wckj-Token')) {
      this.tokenShow = false
    } else {
      this.tokenShow = true
    }
    this.getFirst()
    this.getColumn()
    this.getCityList()
    if (localStorage.getItem('wckj-Token')) {
      this.getUserInfo()
      this.getCartNum()
      this.getActivity()
    }
    console.log(this.themeColor, 215);

  },
  computed: {
    ...mapState(['token', 'cakeCityId', 'cakeCityName', 'cakeCityLocation', 'navBack', 'startColor', 'endColor', 'backColors', 'fontsColor', 'themeColor'])
  },
  methods: {
    // 切换城市
    changeCity (e) {
      this.$store.dispatch('saveCakeCityId', e.id)
      this.$store.dispatch('saveCakeCityName', e.name)
    },
    // 登录
    goLogin () {
      this.$router.push('/login');
    },
    // 搜索、跳转商品列表
    jumpList (item, type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      console.log(item);
      if (item.categoryType == 2) {
        this.$store.dispatch('saveCakeParams', '')
        this.$router.push('/cakeList')
      } else {
        this.$store.dispatch('saveCategoryTitle', item.name)
        this.$store.dispatch('saveCategoryId', item.id)
        this.$store.dispatch('saveRecommendType', '')
        this.$store.dispatch('saveBrandId', '')
        let goodsInfo = {
          tabIndex: 1,
          keyword: '',
          brandId: '',
          thirdId: item.id,
          categoryTitle: item.name,
          pageNum: 1,
          sortField: '',
          sortAsc: true,
          recommendType: ''
        }
        this.$store.dispatch('saveWebGoodsInfo', JSON.stringify(goodsInfo))
        this.$router.push({
          name: 'goodsList',
        });
      }
    },
    handleCommand (e) {
      if (e == 1) {
        this.$router.push({
          name: 'userInfo',
        });
      } else if (e == 2) {
        this.$confirm('确认退出吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          this.$router.push('/login')
          // this.$cookie.set('wckj-Token', '', { expires: '-1' });
          localStorage.removeItem('wckj-Token')
          this.$store.dispatch('saveToken', '');
        }).catch(() => {
          console.log('取消');
        });
      }
    },
    // 跳转电影订单
    jumpMovieOrder () {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', 11)
      this.$router.push('/movieOrderList');
    },
    // 跳转我的订单
    jumpOrder () {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', 1)
      this.$store.dispatch('saveOrderType', 1)
      this.$router.push('/orderList');
    },
    // 跳转个人中心
    toPersonalCenter () {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', '')
      this.$router.push('/userInfo');
    },
    // 跳转活动专区
    jumpActivity () {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push({
        name: "activityList",
      });
    },
    // 跳转模块
    jumpModule (type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (type == 1) {
        this.$store.dispatch('saveJDGoodsInfo', '')
        this.$router.push('/jdList');
      } else if (type == 2) {
        this.$store.dispatch('saveCakeParams', '')
        this.$router.push('/cakeList')
      } else if (type == 3) {
        this.$store.dispatch('saveMovieInfo', {})
        this.$router.push('/movieZone')
      } else {
        // this.$message.warning('敬请期待！')
        this.$store.dispatch('saveCouponInfo', '')
        this.$router.push('/couponList')
      }
    },
    // 跳转积分商城
    jumpIntegral () {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push({
        name: "integralList",
      });
    },
    // 跳转栏目
    jumpColumn (item) {
      this.$store.dispatch('saveColumnId', item.id)
      this.$router.push({
        name: "columnList",
      });
    },
    // 跳转购物车
    jumpCar () {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push('/cart');
    },
    // 鼠标移入事件
    hoverFirst (item) {
      // this.firstItem = item
      // this.show = true
      // this.getSecond()
    },
    // 鼠标移出事件
    outFirst () {
      this.show = false
    },
    // 获取一级分类
    getFirst () {
      this.$api.mall.getFirstLevelCategory().then((res) => {
        console.log(res, '一级分类');
        if (res.code == 200) {
          this.firstList = res.data
        }
      });
    },
    // 获取二级分类
    getSecond () {
      this.$api.mall.getSecondLevelCategory({
        parentId: this.firstItem.id,
      }).then((res) => {
        console.log(res, '二级分类');
        if (res.code == 200) {
          this.secondList = res.data
        }
      });
    },
    // 获取栏目信息
    getColumn () {
      this.$api.mall.getColumnAll().then((res) => {
        console.log(res, '栏目信息');
        if (res.code == 200) {
          this.columnList = res.data
        }
      });
    },
    // 获取个人信息
    getUserInfo () {
      this.$api.mall.getInfo().then((res) => {
        console.log(res, '个人信息');
        if (res.code == 200) {
          this.userInfo = res.data.userInfo
        }
      });
    },
    // 获取购物车数量
    getCartNum () {
      this.$api.mall.getCarCount().then(res => {
        if (res.code == 200) {
          this.$store.dispatch('saveCarCount', res.data)
          this.cartNum = res.data
        }
      })
    },
    // 获取活动
    async getActivity () {
      await this.$api.mall.getCompanyActivity().then((res) => {
        console.log(res, '活动');
        if (res.code == 200) {
          if (res.data) {
            this.companyActivity = res.data
          }
        }
      });
    },
    // getLocation () {
    //   let that = this
    //   console.log(that.cakeCityId, '城市id');
    //   console.log(that.cakeCityName, '城市名字');
    //   if (!that.cakeCityId) {
    //     window.addEventListener('message', function (event) {
    //       if (event.data != null) {//这个会获取到四条数据，其中有一条数据为null，然后你如果是用变量去获取，会报错
    //         if (event.data.module == 'geolocation') {//去掉一条null后还有一条杂数据，里面没啥东西，然后你要是用变量获取位置还是会报错，所有过滤掉非该类型的数据
    //           if (this.isLocation) {
    //             return
    //           }
    //           console.log(event.data, 330);// 显示你当前位置，里面有国家、省份、市、经纬度、邮政编码
    //           that.isLocation = true
    //           that.defCityName = event.data.city
    //           if (!that.cityId) {
    //             that.getCityIdByCityName()
    //           }
    //         }
    //       }
    //     }, false);
    //   } else {
    //     that.defCityName = that.cakeCityName
    //     that.$forceUpdate()
    //   }
    // },
    getlocation () {
      // let that = this
      // if (!that.cakeCityId) {
      //   this.$nextTick(function () {
      //     try {
      //       const geolocation = new BMap.Geolocation();
      //       geolocation.getCurrentPosition(function (res) {
      //         console.log(res, "aaaa");
      //         if (that.isLocation) {
      //           return
      //         }
      //         console.log(res.address.city, 330);// 显示你当前位置，里面有国家、省份、市、经纬度、邮政编码
      //         that.isLocation = true
      //         that.defCityName = res.address.city
      //         let obj = {
      //           longitude: res.longitude,
      //           latitude: res.latitude
      //         }
      //         that.$store.dispatch('saveCakeCityLocation', obj)
      //         if (!that.cityId) {
      //           that.getCityIdByCityName()
      //         }
      //       });
      //     } catch (e) {
      //       console.log(e)
      //     }
      //   })
      // } else {
      //   that.defCityName = that.cakeCityName
      //   that.$forceUpdate()
      // }
      let that = this
      if (!that.cakeCityId) {
        this.$api.mall.getIpLngAndLat().then((res) => {
          console.log(res, '位置信息');
          if (res.code == 200) {
            if (!res.data.content) {
              that.defCityName = '郑州市'
              let obj = {
                longitude: 113.63141921,
                latitude: 34.75343885
              }
              this.$store.dispatch('saveCakeCityLocation', obj)
              that.getCityIdByCityName()
              that.getMovieByCityName()
            } else {
              that.isLocation = true
              console.log(res.data.content.address_detail.city);

              that.defCityName = res.data.content.address_detail.city
              let obj = {
                longitude: res.data.content.point.x,
                latitude: res.data.content.point.y
              }
              that.$store.dispatch('saveCakeCityLocation', obj)
              if (!that.cityId) {
                that.getCityIdByCityName()
                that.getMovieByCityName()
              }
            }

          }
        });
      } else {
        that.defCityName = that.cakeCityName
        that.$forceUpdate()
      }
    },
    // 通过城市名获取城市id
    getCityIdByCityName () {
      this.$api.mall.getCityIdByCityName({
        cityName: this.defCityName
      }).then((res) => {
        console.log(res, '城市id');
        if (res.code == 200) {
          this.cityId = res.data
          this.$store.dispatch('saveCakeCityId', res.data)
          this.$store.dispatch('saveCakeCityName', this.defCityName)
        }
      });
    },
    // 根据城市名字获取城市信息 电影
    getMovieByCityName () {
      this.$api.mall.getMovieByCityName({
        cityName: this.cakeCityName
      }).then((res) => {
        if (res.code == 200) {
          this.$store.dispatch('saveMovieCityId', res.data.cityId)
          this.$store.dispatch('saveMovieCityName', res.data.cityName)
        }
      })
    },
    // 获取城市列表
    getCityList () {
      this.$api.mall.getCityList().then((res) => {
        console.log(res, '城市列表');
        if (res.code == 200) {
          this.cityList = res.data
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  cursor: pointer;
  .nav-topbar {
    height: 39px;
    line-height: 39px;
    background-color: #f2f5f8;
    color: #b0b0b0;

    .container {
      width: 100%;
      display: flex;
      justify-content: space-between !important;
      align-items: center;
      padding: 0 200px;
      box-sizing: border-box;
      .left {
        display: flex;
        align-items: center;
        .el-select {
          width: 150px;
          border-color: transparent;
        }
        .el-input {
          border: none !important;
        }
        .el-select__caret {
          height: 32px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .line {
          width: 1px;
          height: 14px;
          background-color: #cccccc;
          margin: 0 14px;
        }
        .name {
          font-size: 14px;
          color: #4c4948;
        }
        .login-box {
          width: 100px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 16px;
          color: #000;
          .login {
            color: #ff0000;
            font-weight: bold;
            margin-left: 3px;
          }
        }
      }
    }
  }
  .nav-headers {
    width: 100%;
    // height: 162px;
    background-color: #e8e8e8;
    padding: 25px 200px 0;
    box-sizing: border-box;
    .box1 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
        .logo {
          width: auto;
          height: 68px;
        }
        .line {
          width: 1px;
          height: 28px;
          background-color: #c4d0df;
          margin: 0 20px;
        }
        .name {
          font-size: 20px;
          font-weight: bold;
          color: #4c4948;
        }
      }
      .inp_box {
        width: 800px;
        height: 42px;
        border: 2px solid #707070;
        background-color: #ffffff;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin: 0 30px;
        img {
          width: auto;
          height: 16px;
        }
        .word {
          flex: 1;
          height: 42px;
          line-height: 42px;
          border: none;
          font-size: 14px;
          padding: 0 10px;
          box-sizing: border-box;
          color: #999;
        }
        .btn {
          width: 86px;
          height: 42px;
          background-color: #004098;
          text-align: center;
          line-height: 42px;
          font-size: 14px;
          color: #ffffff;
          border-radius: 0;
        }
      }
      .car_box {
        width: 180px;
        height: 42px;
        border: 1px solid #dddddd;
        background-color: #ffffff;
        padding: 0 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        i {
          font-size: 24px;
          color: #004098;
        }
        .word {
          font-size: 14px;
          color: #004098;
          padding: 0 10px;
          box-sizing: border-box;
        }
        .num {
          display: inline-block;
          padding: 0 5px;
          box-sizing: border-box;
          background-color: #c0daf5;
          border-radius: 2px;
        }
      }
    }
    .box2 {
      width: 100%;
      display: flex;
      align-items: center;
      margin-top: 20px;
      .fenlei {
        width: 192px;
        height: 42px;
        background-color: #004098;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .name-box {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            font-size: 24px;
            color: #fff;
          }
          .word {
            font-size: 18px;
            color: #fff;
            font-weight: bold;
            margin-left: 24px;
          }
        }

        .category {
          position: relative;
          position: absolute;
          top: 42px;
          left: 0;
          z-index: 10;
          .childrenOne {
            height: 440px; /*no*/
            // opacity: 1;
            // background-color: rgba(255, 255, 255, 0.5);
            overflow-y: scroll;
            overflow: auto;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            .itemCheck {
              background-color: #fff !important;
            }
            .item {
              width: 192px;
              height: 44px; /*no*/
              background-color: rgba(255, 255, 255, 0.8);
              border-bottom: 1px solid #ffffff;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #000000;

              img {
                width: auto;
                height: 26px;
              }
              .word {
                width: 90px;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-break: break-all;
              }
              &::after {
                position: absolute;
                right: 30px;
                top: 17.5px;
                content: "";
              }
              &:hover {
                background-color: #fff;
                color: #000 !important;
                // .childrenTwo {
                //   display: block;
                // }
              }
            }
          }

          .childrenOne::-webkit-scrollbar {
            display: none;
          }
          .childrenTwo {
            width: 1000px;
            height: 400px; /*no*/
            overflow-y: scroll;
            display: block;
            background-color: #fff;
            box-shadow: 0px 3px 6px 3px rgba(0, 0, 0, 0.05);
            padding: 24px;
            box-sizing: border-box;
            position: absolute;
            top: 0;
            left: 192px;
            z-index: 10;
            .two {
              width: 100%;
              padding: 12px 0 6px;
              box-sizing: border-box;

              .second {
                font-size: 14px;
                color: #4c4948;
                font-weight: bold;
                margin-left: 10px;
              }
              .third_box {
                flex: 1;
                display: grid;
                grid-template-columns: repeat(auto-fill, 100px);
                justify-content: space-between;
                grid-row-gap: 14px;
                .third {
                  // flex: 1;
                  padding: 0 10px;
                  box-sizing: border-box;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: 16px;
                  .third_item {
                    width: 100%;
                    //height: 100px;
                    border-radius: 4px;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
                    background-color: #ffffff;
                    img {
                      width: 80px;
                      height: 80px;
                      border-radius: 4px 4px 0 0;
                      display: inline-block;
                    }

                    .third_name {
                      width: 80px;
                      height: 30px;
                      flex: 1;
                      font-size: 12px;
                      line-height: 30px;
                      color: #4c4948;
                      padding: 0 5px;
                      box-sizing: border-box;
                      text-align: center;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      -webkit-box-orient: vertical;
                      word-break: break-all;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .tabs {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 100px;
        box-sizing: border-box;
        color: #4c4948;

        .word {
          flex: 1;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
        }
        .check {
          color: #004098;
        }
      }
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #4c4948;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>